const map = {
	"./2026_TS_Online_Terms_of_Service_CrossLink_Online.pdf": "./public/documents/2026_TS_Online_Terms_of_Service_CrossLink_Online.pdf",
	"./2027_TS_Online_Terms_of_Service_SmartWiz_Clean.pdf": "./public/documents/2027_TS_Online_Terms_of_Service_SmartWiz_Clean.pdf",
	"./Privacy_Policy_CrossLink_FOC_1.1.2025_v2.pdf": "./public/documents/Privacy_Policy_CrossLink_FOC_1.1.2025_v2.pdf",
	"./SMS-Messaging-Terms-1.1.2023.pdf": "./public/documents/SMS-Messaging-Terms-1.1.2023.pdf",
	"./privacy-policy-updated-september-2020.pdf": "./public/documents/privacy-policy-updated-september-2020.pdf",
	"./sms-messaging-terms-july-2020.pdf": "./public/documents/sms-messaging-terms-july-2020.pdf"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./public/documents sync \\.pdf$";